const useLogger = (): ((message: string, data: any) => void) => {
  const userEmail = localStorage.getItem('userEmailId');
  return (message: string, data: any): void => {
    console.log(message, data, userEmail, 'shell-app');
  };
};

export default useLogger;
